/**
 * Modules Index
 * Central export point for all domain services
 */

import { calendarService } from './calendar/service';
import { fitnessService } from './fitness/service';
import { homeService } from './home/service';
import { settingsService } from './settings/service';
import { studiumService } from './studium/service';
import { toolsService } from './tools/service';

export { homeService } from './home/service';
export { calendarService } from './calendar/service';
export { fitnessService } from './fitness/service';
export { studiumService } from './studium/service';
export { toolsService, flashcardsService } from './tools/service';
export { settingsService, type Theme, type Language } from './settings/service';

/**
 * Initialize all services with user context
 */
export function initializeServices(userId: string): void {
  const services = [
    calendarService,
    fitnessService,
    homeService,
    studiumService,
    toolsService,
    settingsService,
  ];

  services.forEach((service) => {
    if (service && typeof service.setUserId === 'function') {
      service.setUserId(userId);
    }
  });
}

